// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Moderation_wrapper__3KJeQ","block":"Moderation_block__3RLIh"};